import Model from "../core/Model";
import City  from "./City";
import Event from "./Event";
import Venue from "./Venue";
import Media from "./Media";
import User from "./User";
import Logo from "./Logo";




export default class Post extends Model{

    constructor( options = {} ) {

        super('/api/v1/posts');

        this.setOptions(options);

    }

    setOptions( options = {} ) {

        this.id         = options.id                || null;
        this.name       = options.name              || null;
        this.slug       = options.slug              || null;
        this.logo       = new Logo(options.logo     || {});
        this.photo      = new Media(options.photo   || {});
        this.logoUrl    = options.logoUrl           || null;
        this.web        = options.web               || null;
        this.address    = options.address           || null;
        this.zip        = options.zip               || null;
        this.city       = new City(options.city     || {});
        this.user       = new User(options.user     || {});

    }

    toJson (){

        return {
            'id'        : this.id      ,
            'name'      : this.name    ,
            'slug'      : this.slug    ,
            'logo'      : this.logo.toJson()    ,
            'photo'     : this.photo.toJson()   ,
            'logoUrl'   : this.logoUrl ,
            'web'       : this.web     ,
            'address'   : this.address ,
            'zip'       : this.zip     ,
            'city'      : this.city.toJson()    ,
            'user'      : this.user.toJson()    ,

        }
    }

}




// WEBPACK FOOTER //
// ./resources/js/models/Venue.js